import _defineProperty from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
export default {
  data: function data() {
    return _defineProperty({
      data01: 'All New MG5',
      data02: 'New MG Extender DC',
      data03: 'New MG Extender GC'
    }, "data03", 'New MG EP Plus');
  },
  methods: {
    back: function back() {
      var _this = this;
      var timer = setTimeout(function () {
        _this.$router.back();
        clearTimeout(timer);
      }, 100);
    },
    toDetail: function toDetail(name) {
      this.$router.push({
        path: '/social/manualDetails',
        query: {
          name: name
        }
      });
    }
  }
};